/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import * as ConfiguratorSelectors from './configurator-group.selectors';
export { ConfiguratorSelectors };
